import styled from 'styled-components';
import { media } from 'designsystem/index';

const PhoneScreenImageWrapper = styled.div`
  position: absolute;
  top: 54px;
  left: 68px;
  width: 129px;
  height: 225px;
  transform-origin: right;
  overflow: hidden;
  
  box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.5);
  
  ${media.tablet`
    top: 63px;
    left: 81px;
    width: 151px;
    height: 265px;
  `}
  
  ${media.desktop`
    top: 97px;
    left: 125px;
    width: 230px;
    height: 406px;
  `};
`;

export default PhoneScreenImageWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImageWrapper.jsx